import { usePopupPosition as lib } from 'use-rects';

export const usePopupPosition = () => lib({ delay: 20, trackVisible: false });
